import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { PoBreadcrumb, PoDialogService, PoDynamicFormField, PoLookupColumn, PoModalAction, PoModalComponent, PoSelectOption, PoTableColumn } from '@po-ui/ng-components';
import { Fornecedor, getFornecedorDefault } from 'src/app/interface/fornecedor';
import { MunicipioIBGE } from 'src/app/interface/municpio-ibge';
import { CEPService } from 'src/app/service/cep-service';
import { MunicipioIBGEService } from 'src/app/service/municipio-ibge-service';
import { UtilService } from 'src/app/service/util';
import { getProcessoCadastroRevisaoFornecedorDefault, ProcessoCadastroRevisaoFornecedor } from '../../../interface/processo-revisao-cadastro-fornecedor';
import { getProcessoCadastroHistoricoDefault, ProcessoCadastroHistorico } from '../../../interface/processo-cadastro-historico';
import { FornecedorLookupService } from 'src/app/service/fornecedor-lookup-service';
import { FornecedorService } from 'src/app/service/fornecedor-service';
import { ProcessoCadastroService } from 'src/app/administrativo/service/processo-cadastro';

@Component({
  selector: 'app-revisao-cadastro-fornecedor-aprovar',
  templateUrl: './revisao-cadastro-fornecedor-aprovar.component.html',
  styleUrls: ['./revisao-cadastro-fornecedor-aprovar.component.css']
})
export class RevisaoCadastroFornecedorAprovarComponent implements OnInit {

  processoCadastroFornecedor: ProcessoCadastroRevisaoFornecedor;
  fornecedor: Fornecedor;
  fornecedorDto: ProcessoCadastroRevisaoFornecedor;
  observacaoEntidade: string;
  NCODIGO: number;
  listaEstado: Array<PoSelectOption>;
  bloqueiaCampo: string;
  lbloqueiaCampo: boolean;
  itensHistorico: Array<ProcessoCadastroHistorico>;

  observacaoRejeicao: string = '';

  advancedMunicipioIBGEFilters: Array<PoDynamicFormField>;
  columnsMunicipioIBGEFilters: Array<PoLookupColumn>;
  fieldFormaterMunicipioIBGEFilters: ((value: MunicipioIBGE) => string);

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    public fornecedorLookupService: FornecedorLookupService,
    public fornecedorService: FornecedorService,
    public processoCadastroService: ProcessoCadastroService,
    public municipioIBGEService: MunicipioIBGEService,
    private poDialog: PoDialogService,
    public utilService: UtilService,
    public cepService: CEPService,
  ) {
    this.processoCadastroFornecedor = getProcessoCadastroRevisaoFornecedorDefault();
    this.fornecedor = getFornecedorDefault();
    this.fornecedorDto = getProcessoCadastroRevisaoFornecedorDefault();
    this.NCODIGO = 0;
    this.listaEstado = utilService.getListaEstados();
    this.bloqueiaCampo = "true";
    this.lbloqueiaCampo = true;
    this.itensHistorico = [];
    this.observacaoEntidade = '';

    this.advancedMunicipioIBGEFilters = this.municipioIBGEService.getAdvancedFilter();
    this.columnsMunicipioIBGEFilters = this.municipioIBGEService.getColumnsFilter();
    this.fieldFormaterMunicipioIBGEFilters = this.municipioIBGEService.getFieldFormater;
  }

  @ViewChild('formCadastroFornecedor', { static: true }) formCadastroFornecedor!: NgForm;
  @ViewChild('rejeitarModal', { static: true }) rejeitarModal!: PoModalComponent;

  public readonly breadcrumb: PoBreadcrumb = {
    items: [{label: 'Home', action: this.goTo.bind(this)},
      {label: 'Processo Cadastro', action: this.goTo.bind(this)},
      {label: 'Editar', action: this.goTo.bind(this)},
    ]
  };

  goTo(label: string): void {
    if (label === 'Home') {
      this.router.navigateByUrl('/');
    } else {
      this.router.navigateByUrl('/administrativo/revisao-cadastro/lista');
    }
  }

  ngOnInit(): void {

    this.route.params.subscribe((params) => {
      if ('NCODIGO' in params) {
        this.NCODIGO = params['NCODIGO'];
      }
    })

    this.loadData();

  }

  loadData(): void{

    this.processoCadastroService.getProcCadastroFornecedor(this.NCODIGO).subscribe(processoCadastroFornecedor => {
      this.processoCadastroFornecedor = processoCadastroFornecedor;
      this.municipioIBGEService.estado = this.processoCadastroFornecedor.fornecedor.CA2EST;
      this.processoCadastroFornecedor.CCODIGOLOJA = `${this.processoCadastroFornecedor.fornecedor.CA2COD}/${this.processoCadastroFornecedor.fornecedor.CA2LOJA}`

      if (this.processoCadastroFornecedor.CSTATUS_PROCESSO === 'C'){
        this.bloqueiaCampo = "false";
        this.lbloqueiaCampo = false;
      }

      this.processoCadastroService.getProcCadastroHistoricoLista(this.NCODIGO).subscribe(listaHistorico => {
        this.itensHistorico = listaHistorico.items;
        this.itensHistorico.forEach(item => {
          if ( item.CSTATUS === 'C' ){
            this.observacaoEntidade = item.COBSERVACAO;
          }
        })
      });

      this.fornecedorLookupService.getObjectByValue(`${this.processoCadastroFornecedor.fornecedor.CA2COD}${this.processoCadastroFornecedor.fornecedor.CA2LOJA}`,"C").subscribe(fornecedor => {

        this.fornecedor = {... fornecedor};

        this.fornecedorDto = processoCadastroFornecedor;

        this.fornecedorDto.fornecedor.CA2NATUREZ = this.fornecedor.CA2NATUREZ

      });

    });
  }

  openModalConfirmar() {
    this.poDialog.confirm({
      title: 'Confirmar Cadastro',
      message: 'Deseja realmente confirmar os dados apresentados?',
      confirm: () => this.salvar()
    });
  }

  openModalRejeitar() {
    this.rejeitarModal.open();
  }

  salvar() {

    this.fornecedorService.postFornecedor(this.fornecedorDto.fornecedor).subscribe(() => {
      let processoCadastroHistorico = getProcessoCadastroHistoricoDefault();
      processoCadastroHistorico.NCODIGOPROCESSOCADASTRO = this.fornecedorDto.NPROCESSO;
      processoCadastroHistorico.CSTATUS = 'F';
      processoCadastroHistorico.COBSERVACAO = 'PROCESSO APROVADO';
      this.processoCadastroService.postHistorico(processoCadastroHistorico).subscribe(() => {
        this.poDialog.alert({
          title: 'Processo Finalizado',
          message: 'Processo Finalizado com Sucesso',
          ok: () => this.goTo('')
        });
      });
    });

  }

  rejeitar() {
    this.processoCadastroService.postFornecedorRejeitar(this.NCODIGO, this.observacaoRejeicao).subscribe(() => {
      let processoCadastroHistorico = getProcessoCadastroHistoricoDefault();
      processoCadastroHistorico.NCODIGOPROCESSOCADASTRO = this.fornecedorDto.NPROCESSO;
      processoCadastroHistorico.CSTATUS = 'P';
      processoCadastroHistorico.COBSERVACAO = 'PROCESSO REJEITADO';
      this.processoCadastroService.postHistorico(processoCadastroHistorico).subscribe(() => {
        this.poDialog.alert({
          title: 'Processo Rejeitado',
          message: 'Processo Rejeitado com Sucesso',
          ok: () => this.goTo('')
        });
      });
    });

  }

  municipioIBGESelecionado(row: MunicipioIBGE) {
    this.fornecedorDto.fornecedor.CA2MUN = row.CCC2MUN;
  }

  validForm(): boolean {
    return !(this.formCadastroFornecedor.valid && !this.lbloqueiaCampo);
  }

  alteraCep() {
    this.cepService.getObjectByValue(this.fornecedorDto.fornecedor.CA2CEP).subscribe(cep => {
      if (cep.cep) {
        this.fornecedorDto.fornecedor.CA2END = `${cep.logradouro.toUpperCase()}, `;
        this.fornecedorDto.fornecedor.CA2BAIRRO = cep.bairro.toUpperCase();
        this.fornecedorDto.fornecedor.CA2EST = cep.uf;
        this.fornecedorDto.fornecedor.CA2COD_MUN = cep.ibge.substring(2, 7);
        this.municipioIBGEService.estado = cep.uf;
      } else {
        this.fornecedorDto.fornecedor.CA2END = '';
        this.fornecedorDto.fornecedor.CA2BAIRRO = '';
        this.fornecedorDto.fornecedor.CA2EST = '';
        this.fornecedorDto.fornecedor.CA2COD_MUN = '';
        this.municipioIBGEService.estado = '';
      }
    });

  }

  public colunasHistorico: Array<PoTableColumn> = [
    {
      property: 'CSTATUS',
      type: 'subtitle',
      width: '7%',
      label: 'Status',
      visible: true,
      subtitles: [
        {value: 'P', color: 'color-01', content: 'P', label: 'Pendente'},
        {value: 'C', color: 'color-10', content: 'C', label: 'Confirmado'},
        {value: 'R', color: 'color-10', content: 'R', label: 'Reenvio'},
        {value: 'F', color: 'color-07', content: 'F', label: 'Finalizado'},
      ]
    },
    {property: 'DDATA'                      , width: '7%' , visible: true, label: 'Data'      , type: 'date'},
    {property: 'CHORA'                      , width: '7%', visible: true, label: 'Hora'},
    {property: 'CCODIGOUSUARIOPROTHEUS_NOME', width: '10%', visible: true, label: 'Usuário'},
    {property: 'COBSERVACAO'                , width: '50%', visible: true, label: 'Observação'},

  ];

  public readonly rejeitarCadastroAction: PoModalAction = {
    action: () => {

      this.rejeitarModal.close();
      this.rejeitar();
    },
    label: 'Rejeitar',
  };

}
